import React from 'react';
import LoadingIcon from '../../../assets/icons/icon-loading-green.svg';
import './_loadingSpinner.scss';

type LoadingSpinnerProps = {
  classes?: string;
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ classes }) => (
  <div className={`${'c_loading-spinner'} ${classes || ''}`}>
    <LoadingIcon />
    <span className={'u_visuallyhidden'}>Laster. Vennligst vent</span>
  </div>
);

export { LoadingSpinner };
